import { Injectable, Renderer2, RendererFactory2, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private darkMode = new BehaviorSubject<boolean>(false);
  darkMode$ = this.darkMode.asObservable();
  private isBrowser: boolean;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(PLATFORM_ID) platformId: Object
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.isBrowser = isPlatformBrowser(platformId);
    this.initTheme();
  }

  private initTheme(): void {
    // Skip initialization on server-side
    if (!this.isBrowser) {
      return;
    }

    // Check if user has previously selected a theme
    const storedTheme = localStorage.getItem('theme');
    
    // Check if user prefers dark mode
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    const isDark = storedTheme === 'dark' || (!storedTheme && prefersDark);
    
    this.setTheme(isDark);
  }

  setTheme(isDark: boolean): void {
    // Skip on server-side
    if (!this.isBrowser) {
      this.darkMode.next(isDark);
      return;
    }

    if (isDark) {
      this.renderer.addClass(document.documentElement, 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      this.renderer.removeClass(document.documentElement, 'dark');
      localStorage.setItem('theme', 'light');
    }
    
    this.darkMode.next(isDark);
  }

  toggleTheme(): void {
    this.setTheme(!this.darkMode.value);
  }
}